namespace Gamification.Gamification {
    export interface ProdottiAssetEsperienzeForm {
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdProdotto: Serenity.IntegerEditor;
        IdAssetEsperienza: Serenity.IntegerEditor;
    }

    export class ProdottiAssetEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiAssetEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiAssetEsperienzeForm.init)  {
                ProdottiAssetEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ProdottiAssetEsperienzeForm, [
                    'UserId', w0,
                    'TenantId', w0,
                    'IdProdotto', w0,
                    'IdAssetEsperienza', w0
                ]);
            }
        }
    }
}
